export class QrefOkwedModel {
  kod: string;
  name: string;

  constructor() {
  }
}

